export default __webpack_public_path__ + "static/media/SndLowerZSlideDown.a703995a.mp3";